import { motion } from 'framer-motion';
import { FaMoon, FaPalette, FaSun } from 'react-icons/fa';
import { useTheme } from './ThemeContext';

const themes = {
  dark: { name: 'Oscuro' },
  light: { name: 'Claro' },
  blue: { name: 'Azul' },
  purple: { name: 'Púrpura' },
};

export default function Header() {
  const { isDarkMode, toggleTheme, currentTheme, setTheme } = useTheme();

  const handleThemeChange = () => {
    const themeKeys = Object.keys(themes);
    const currentIndex = themeKeys.indexOf(currentTheme);
    const nextIndex = (currentIndex + 1) % themeKeys.length;
    setTheme(themeKeys[nextIndex]);
  };

  return (
    <>
      <motion.header initial={{ y: -100 }} animate={{ y: 0 }} className='flex fixed top-0 z-10 justify-center items-center mx-auto mt-2 w-full'>
        <nav className={`flex justify-center items-center px-3 rounded-full md:max-ssm::flex font-medium text-sm text ${isDarkMode ? 'dark' : ''} ${isDarkMode ? 'dark:text-gray-200' : ''}`}
          style={{ backgroundColor: isDarkMode ? '#1f2937e6' : '#ffffff80' }}>
          <a href='https://instagram.com/carlosdelviento.dev' className='flex hidden mr-10 font-bold transition-colors align-items-center justify-content-center md:flex lg:flex xl:flex text-md hover:text-accent fle jus justif l-5 text' aria-label='Home' target='_blank' rel='noopener noreferrer'>
            carlosdelviento.dev
          </a>
          <a href='#experience' className='block relative px-2 py-2 ml-4 transition-colors hover:text-accent dark:hover:accent-secondary text' aria-label='Experience'>
            Experience
          </a>
          <a href='#projects' className='ml-4 transition hover:text-accent' aria-label='Projects'>
            Projects
          </a>
          <a href='#about' className='ml-4 transition hover:text-accent' aria-label='About me'>
            About
          </a>
          <a href='mailto:carlosdelviento23@gmail.com' target='_blank' rel='noopener noreferrer' role='link' className='ml-4 transition hover:text-accent' aria-label='Contact'>
            Contact
          </a>
          <button onClick={toggleTheme} className='p-2 ml-4 rounded-full transition-colors dark:hover:bg-gray-800 hover:text-accent'
            aria-label='Toggle dark mode'>
            {isDarkMode ? (
              <FaMoon className='w-4 h-4' />
            ) : (
              <FaSun className='w-4 h-4' />
            )}
          </button>
          <button
            onClick={handleThemeChange}
            className='p-2 ml-4 rounded-full transition-colors hover:text-accent'
            aria-label='Change color theme'
          >
            <FaPalette className='w-4 h-4' />
          </button>
        </nav>
      </motion.header>
    </>
  );
}